import saveAs from "file-saver";
import { MainContainer } from './styles';
import { ColumnProps, DataTable } from "components/Table";
import { useEffect, useRef, useState } from "react";
import { PageContainer } from 'components/PageContainer'
import { Toolbar } from "components/Toolbar";
import { Popup } from "components/Popup";
import { ObservationForm } from "components/PopupForms/ObservationForm";
import { IBoxes } from 'interfaces/IBoxes';
import { FormTableLine } from './FormTable';
import { useMediaQuery } from 'react-responsive';
import { toast } from 'react-toastify';
import { dateToday } from 'utils/dateToday';
import { boxControlService } from 'services/boxControlService';
import { IDriver } from 'interfaces/IDriver';
import { BoxHistoryForm } from 'components/PopupForms/BoxHistoryForm';
import { ICheckboxOption } from 'components/checkbox';
import { ConfirmPopup } from './ConfirmChangeDriverPopup';
import { routeService } from 'services/routeService';
import { IDriverChangeHistory } from 'components/PopupForms/ShowDriverChangeHistory';
import { useSearchParams, useNavigate } from "react-router-dom";
import { ActiveFilters } from "components/ActiveFilters";
import dayjs from "dayjs";


export interface IChangeDriverParams {
  waybillId: number;
  vehicleId: number;
  changedVehicleId: number | undefined;
  action: string;
  deliveryDate: string;
}

export interface IConfirmationPopupVisible {
  visible: boolean;
  route: IBoxes | null;
  existentRoute: IBoxes | null;
  onConfirm: () => void;
}

const defaultColumns: ColumnProps[] = [
  {
    name: "Nome",
    align: "left",
  },
  {
    name: "Rotas",
    align: "center",
  },
  {
    name: "Caixas",
    align: "center",
  },
  {
    name: "First Mile",
    align: "center"
  },
  {
    name: "Último Saldo",
    align: "center"
  },
  {
    name: "Centro de Distribuição",
    align: "center",
  },
  {
    name: "",
  }
]

const smallScreenColumns: ColumnProps[] = [
  {
    name: "Nome",
    align: "left",
  },
  {
    name: "Rotas",
    align: "center",
  },
  {
    name: "Caixas",
    align: "center",
  },
  {
    name: "First Mile",
    align: "center"
  },
  {
    name: "Último Saldo",
    align: "center"
  },
  {
    name: "CD",
    align: "center",
  },
  {
    name: "",
  }
]

export function BoxReturn() {
  const smallScreen = useMediaQuery({ maxWidth: 820 })
  const [popupVisible, setPopupVisible] = useState(false)
  const [formEdit, setFormEdit] = useState<IBoxes>({} as IBoxes)
  const [firstMileTeam, setFirstMileTeam] = useState<string[]>([])
  const [data, setData] = useState<IBoxes[]>([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const [params, setParams] = useState(() => {
    const page = Number(searchParams.get("page")) || 1;
    const pageSize = Number(searchParams.get("pageSize")) || 30;
    const search = searchParams.get("search") || '';
    const includeSupportDrivers = searchParams.get("includeSupportDrivers") === "false" ? false : true;
    const startDeliveryDate = searchParams.get("startDeliveryDate") || dateToday();
    const endDeliveryDate = searchParams.get("endDeliveryDate") || dateToday();
    const deliveryDate = searchParams.get("deliveryDate") || dateToday();
    const transshipPointsIdsFromUrl = searchParams.getAll("transshipPointsIds");

    return {
      page,
      pageSize,
      search,
      notPaginated: true,
      includeSupportDrivers,
      startDeliveryDate,
      endDeliveryDate,
      deliveryDate,
      transshipPointsIds: transshipPointsIdsFromUrl.map(id => parseInt(id)).filter(id => !isNaN(id)) || [],
    };
  });

  const [showNegativeBalanceOnly, setshowNegativeBalanceOnly] = useState(false);
  const [includeSupportDrivers, setIncludeSupportDrivers] = useState(params.includeSupportDrivers);

  // Estados para checkboxes pendentes (usados apenas no drawer)
  const [pendingIncludeSupportDrivers, setPendingIncludeSupportDrivers] = useState(params.includeSupportDrivers);
  const [HistoryformEdit, setHistoryFormEdit] = useState<IBoxes>({} as IBoxes)
  const [historyPopupVisible, setHistoryPopupVisible] = useState(false)
  const [loading, setLoading] = useState(true)
  const [formLoading, setFormLoading] = useState(false)
  const oldData = useRef<IBoxes[]>([])
  const [confirmationPopupVisible, setConfirmationPopupVisible] = useState<IConfirmationPopupVisible>({
    visible: false,
    route: null,
    existentRoute: null,
    onConfirm: () => { }
  })
  let columns = smallScreen ? smallScreenColumns : defaultColumns

  const onChangeParams = (newParamsOrFn: Function | typeof params) => {
    const updatedParams = typeof newParamsOrFn === 'function' ? newParamsOrFn(params) : newParamsOrFn;
    const combinedParams = {
      ...params,
      ...updatedParams,
    };
    setParams(combinedParams);
    setSearchParams(combinedParams as any);
  };

  const handleToggleNegativeBalance = () => {
    if (loading) return;
    setshowNegativeBalanceOnly(!showNegativeBalanceOnly);
  };

  const handleToggleSupportDrivers = () => {
    if (loading) return;
    const newValue = !includeSupportDrivers;
    setIncludeSupportDrivers(newValue);
    onChangeParams({ ...params, includeSupportDrivers: newValue });
  };

  // Função para checkboxes do drawer (não aplica imediatamente)
  const handleToggleSupportDriversDrawer = () => {
    if (loading) return;
    setPendingIncludeSupportDrivers(!pendingIncludeSupportDrivers);
  };

  // Checkboxes para o drawer (sem aplicação imediata)
  const drawerCheckboxes: ICheckboxOption[] = [
    {
      id: 'includeSupportDrivers',
      text: 'Motoristas de Suporte',
      handleToggle: handleToggleSupportDriversDrawer,
      state: pendingIncludeSupportDrivers
    }
  ];

  // Mapeador de filtros para ActiveFilters
  const filterMapper = {
    startDeliveryDate: {
      label: "Data início",
      formatValue: (value: string) => {
        try {
          return dayjs(value).format('DD/MM/YYYY');
        } catch {
          return value;
        }
      },
    },
    endDeliveryDate: {
      label: "Data fim",
      formatValue: (value: string) => {
        try {
          return dayjs(value).format('DD/MM/YYYY');
        } catch {
          return value;
        }
      },
      hidden: params.startDeliveryDate === params.endDeliveryDate, // Oculta se for período de um dia
    },
    transshipPointsIds: {
      label: "Pontos de transbordo",
      formatValue: (value: number[]) => `${value.length} selecionado${value.length !== 1 ? 's' : ''}`,
      hidden: !params.transshipPointsIds || params.transshipPointsIds.length === 0,
    },
    includeSupportDrivers: {
      label: "Motoristas de Suporte",
      formatValue: (value: boolean) => value ? "Incluídos" : "Excluídos",
      hidden: params.includeSupportDrivers === true, // Oculta se for o valor padrão
    },
  };

  // Remove um filtro específico
  const handleRemoveFilter = (filterKey: string) => {
    const newParams = { ...params };

    switch (filterKey) {
      case 'startDeliveryDate':
      case 'endDeliveryDate':
        const todayFormatted = dateToday();
        newParams.startDeliveryDate = todayFormatted;
        newParams.endDeliveryDate = todayFormatted;
        newParams.deliveryDate = todayFormatted;
        break;
      case 'transshipPointsIds':
        newParams.transshipPointsIds = [];
        break;
      case 'includeSupportDrivers':
        newParams.includeSupportDrivers = true;
        setIncludeSupportDrivers(true);
        setPendingIncludeSupportDrivers(true);
        break;
      case 'search':
        newParams.search = '';
        break;
      default:
        if (filterKey in newParams) {
          (newParams as any)[filterKey] = undefined;
        }
    }

    newParams.page = 1;
    onChangeParams(newParams);
  };

  // Remove todos os filtros
  const handleClearAllFilters = () => {
    const clearedParams = {
      ...params,
      startDeliveryDate: dateToday(),
      endDeliveryDate: dateToday(),
      deliveryDate: dateToday(),
      transshipPointsIds: [],
      includeSupportDrivers: true,
      search: '',
      page: 1,
    };
    setIncludeSupportDrivers(true);
    setPendingIncludeSupportDrivers(true);
    onChangeParams(clearedParams);
  };

  const submitFormBoxesSent = async (element: IBoxes) => {
    try {
      await boxControlService.submitForm(element)
      toast.success("Dados enviados com sucesso!")
    } catch {
      toast.error("Erro ao submeter os dados")
    }
  }

  const submitFormBoxesReturn = async (element: IBoxes) => {
    try {
      await boxControlService.createBoxReturn(element)
      toast.success("Dados enviados com sucesso!")
    } catch {
      toast.error("Erro ao submeter os dados")
    }
  }

  const updateData = (updatedElement: IBoxes, isOldData?: boolean) => {
    if (isOldData) {
      oldData.current = oldData.current.map((element: IBoxes) =>
        element.id === updatedElement.id ? updatedElement : element
      )
      return
    }

    setData((prevData: IBoxes[]) =>
      prevData.map((element: IBoxes) =>
        element.id === updatedElement.id ? updatedElement : element
      )
    );
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const [response, balance, firstMileTeam, driverChangeHistory] = await Promise.all([
        boxControlService.getBoxesSent(params),
        boxControlService.getBoxesBalance(params),
        boxControlService.getFirstMileCostTeam(),
        routeService.getDriverChangeHistory(params)
      ]);

      const names = ['Sem seleção', ...firstMileTeam.results.map((driver: IDriver) => driver.name)];
      setFirstMileTeam(names);
      const dataPagination = response.results;
      const balanceData = balance.results;

      setLoading(false);

      const newData = joinData(dataPagination, balanceData, driverChangeHistory);
      setData(newData);
      oldData.current = newData;
    } catch (error) {
      setLoading(false);
      toast.error('Erro ao buscar dados no sistema');
    }
  };

  const joinData = (dataPagination: IBoxes[], balanceData: IBoxes[], driverChangeHistoryData: IDriverChangeHistory[]): IBoxes[] => {
    if (!dataPagination || !Array.isArray(dataPagination) || !balanceData || !Array.isArray(balanceData)
        || !driverChangeHistoryData || !Array.isArray(driverChangeHistoryData)) {
      return [];
    }

    const combinedData: IBoxes[] = dataPagination.map((boxesData: IBoxes) => {
      const balance = balanceData.find((balance: IBoxes) => balance.vehicle?.id === boxesData.vehicle?.id);
      const driverChangeHistory = driverChangeHistoryData.filter((history: IDriverChangeHistory) => history.route === String(boxesData.route));
      return {
        ...boxesData,
        lastRoute: balance ? balance : null,
        driverChangeHistory: driverChangeHistory ? driverChangeHistory : undefined
      };
    });

    return combinedData;
  };

  const downloadFile = async () => {
    try {
      setLoading(true);
      const response = await boxControlService.saveFileBoxesReturn(params.startDeliveryDate, params.endDeliveryDate);
      const blob = new Blob([response], { type: 'application/ms-excel;charset=utf-8' });
      saveAs(blob, 'Retorno-de-Caixas.xlsx');
    } catch (e) {
      toast.error("Houve um erro ao tentar baixar a planilha");
    } finally {
      setLoading(false);
    }
  }

  const handleEdit = (data: IBoxes) => {
    setFormEdit(data)
    setPopupVisible(true)
  }

  const handleEditHistory = (data: IBoxes) => {
    setHistoryFormEdit(data)
    setHistoryPopupVisible(true)
  }

  const handleSaveComment = (comment: string) => {
    const newElement = { ...formEdit, returnComment: comment }
    boxControlService.updateComment(newElement)
      .then(e => {
        toast.success("Observação salva com sucesso!")
        fetchData()
      }).catch(e => {
        toast.error("Não foi possível salvar a observação")
      })
  }

  const updateDriver = async (params: IChangeDriverParams) => {
    try {
      toast.info("Aguarde...");

      setLoading(true);

      await routeService.updateLineup(params);

      fetchData();

      toast.success("Motorista atualizado com sucesso!");
    } catch (error: any) {
      toast.error(error.msg || error.message || "Erro ao atualizar motorista");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [params]);

  return (
    <>
      <Popup
        popupTitle='Editar Observação'
        open={popupVisible}
        setOpen={setPopupVisible}
        isEditPopup
        isObservation
        content={<ObservationForm data={formEdit} handleSave={handleSaveComment} />} />
      <Popup
        popupTitle='Saldo Histórico'
        open={historyPopupVisible}
        setOpen={setHistoryPopupVisible}
        isTablePopup
        confirmDelete
        content={<BoxHistoryForm vehicleId={HistoryformEdit?.vehicle?.id} />}
      />
      <ConfirmPopup
        setPopupVisible={setConfirmationPopupVisible}
        popupVisible={confirmationPopupVisible}
      />
      <div className="pageContent">
        <PageContainer>
          <MainContainer>
            <div className='infos'>
              <h3>Devolução de Caixas</h3>
              <Toolbar
                params={params}
                paramState={onChangeParams}
                loadingState={loading}
                placeholder="Motorista, veículo ou rota"
                export
                onDownload={downloadFile}
                page='BoxReturn'
                checkboxes={drawerCheckboxes}
              />
            </div>
            <ActiveFilters
                params={params}
                mapper={filterMapper}
                onRemoveFilter={handleRemoveFilter}
                onClearAll={handleClearAllFilters}
                title="Filtros aplicados"
                hideWhenEmpty={true}
              />
            <DataTable loading={loading} columns={columns} contentHeight="35vh">
              {data
                .filter((element: IBoxes) => !showNegativeBalanceOnly ||
                  ((element.lastRoute?.boxesSent || 0) - (element.lastRoute?.boxesReturned || 0)) > 0)
                .sort((a: IBoxes, b: IBoxes) => a.route - b.route)
                .map((element: IBoxes) => (
                  <FormTableLine
                    key={element.id}
                    element={element}
                    onSubmitSent={submitFormBoxesSent}
                    onSubmitReturn={submitFormBoxesReturn}
                    handleEdit={handleEdit}
                    handleEditHistory={handleEditHistory}
                    firstMileTeam={firstMileTeam}
                    updateData={updateData}
                    oldData={oldData}
                    formLoading={formLoading}
                    setFormLoading={setFormLoading}
                    confirmationPopupVisible={confirmationPopupVisible}
                    setConfirmationPopupVisible={setConfirmationPopupVisible}
                    updateDriver={updateDriver}
                  />
                ))
              }
            </DataTable >
            <div className="spacer" />
          </MainContainer>
        </PageContainer>
      </div>
    </>
  )
}
